import { Component, OnInit, ElementRef, ViewChild, Input } from '@angular/core';
import { from } from 'rxjs';
import { FieldComponent } from '../field.component'

@Component({
  selector: 'app-basic-field-r',
  templateUrl: './basic-field-r.component.html',
  styleUrls: ['./../Field-Styles.scss'],
})
export class BasicFieldRComponent extends FieldComponent implements OnInit {

  constructor() {
    super();
  }

  ngOnInit() {
  }
}
